<template>
  <div class="vacancy-stages">
    <VacancyStage v-for="item in vacancyStages" :key="item.name" :data="item" />
  </div>
</template>

<script>
import { store } from '@/store';
import VacancyStage from './VacancyStage';
export default {
  components: { VacancyStage },
  computed: {
    vacancyStages() {
      return store.state.rightPanel?.metadata?.content?.data || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy-stages {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &__item {
    display: flex;
  }
}
</style>
